import axios from 'axios';

const API_BASE = '/api/sales';

export const salesPortalService = {
  getCustomers: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/customers`, { params });
    return response.data;
  },
  getCustomer: async (id) => {
    const response = await axios.get(`${API_BASE}/customers/${id}`);
    return response.data;
  },
  getCustomerContacts: async (id) => {
    const response = await axios.get(`${API_BASE}/customers/${id}/contacts`);
    return response.data;
  },
};
